module.exports = __webpack_public_path__ + "img/719.379abe2e.png";